<template>
	<div class="app">
		<Icons/>
		<Customizer/>
	</div>
</template>

<script>
import Customizer from './components/Customizer/index';
import Icons from './components/icons';

export default {
	name: 'App',
	components: {
		Icons,
		Customizer,
	},
};
</script>

<style lang="sass">
html, body
	margin: 0
	padding: 0

	font-family: Real Text Offc Regular,sans-serif
	font-weight: 500

h1, h2, h3, h4
	font-family: Real Head Offc Demibold,sans-serif
	font-weight: 500

@font-face
	font-family: 'Real Head Offc Demibold'
	src: url(@/assets/fonts/RealHeadOffc-Demibold.woff2) format("woff2")
	font-weight: 600
	font-style: normal

@font-face
	font-family: 'Real Text Offc Regular'
	src: url(@/assets/fonts/RealTextOffc.woff2) format("woff2")
	font-weight: normal
	font-style: normal

</style>
